import { FC } from "react";
import { NamedNumberic } from "../../../ui/layout/molecules/NamedNumberic";
import { boostingNumberProps } from "../constants";
import { parseNumberOrZero } from "../../../helpers";

export const WeightNumberInput: FC<{
  title?: string;
  value: number;
  onChange: (weight: number) => void;
}> = ({ title = "Weight", value, onChange }) => (
  <NamedNumberic
    title={title}
    value={value}
    onChange={(target) => onChange(parseNumberOrZero(target.value))}
    {...boostingNumberProps}
  />
);
